import { object, string } from 'yup';
import type { ValidationErrors } from 'final-form';
import type { ObjectSchema} from 'yup';
import type { ObjectShape } from 'yup/lib/object';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';
import type { VarFilterDto } from '@src/api';

const validateSchema = (filters): ObjectSchema<ObjectShape> =>
  object().shape({
    orGroup: string().nullable().required(),
    andGroup: string()
      .nullable()
      .required()
      .test(
        'andGroup',
        'Номер правила с такой последовательностью условий уже существует',
        (value, { parent: { orGroup, id } }) =>
          !filters
            .filter((item) => item.id !== id)
            .find((item) => item.orGroup === +orGroup && item.andGroup === +(value ?? 0)),
      ),
    fieldName: textValidator({ fieldName: 'fieldName' }),
    selOption: textValidator({ fieldName: 'selOption' }),
    fieldValue: textValidator({ fieldName: 'fieldValue', required: false }),
  });

export const validate = (
  filters: VarFilterDto[],
): ((values: unknown) => ValidationErrors | Promise<ValidationErrors> | undefined) =>
  createValidator(validateSchema(filters));
